import { useEffect, useState } from 'react';

type ReturnType<T> = [
    value: T,
    setValue: (newValue: T) => void,
];

export default <T>(inputValue: T): ReturnType<T> => {
  const [value, setValue] = useState(inputValue);

  useEffect(() => {
    setValue(inputValue);
  }, [inputValue]);

  return [value, setValue];
};
